import Service from 'ember-simple-auth/services/session';

type UserData = {
  id: string;
  email: string;
  name?: string;
  role?: string;
};

type Data = {
  authenticated: {
    accessToken: string;
    user?: UserData;
  };
};

export default class Session extends Service<Data> {
  get accessToken(): string | undefined {
    // Access isAuthenticated to establish Glimmer tracking dependency.
    // session.data is not tracked by Glimmer, but isAuthenticated is,
    // so this ensures the getter re-computes after login/logout.
    if (!this.isAuthenticated) return undefined;
    return this.data.authenticated?.accessToken;
  }

  get authHeader(): string | undefined {
    const accessToken = this.accessToken;
    return accessToken ? `Bearer ${accessToken}` : undefined;
  }

  get user(): UserData | undefined {
    // Access isAuthenticated to establish Glimmer tracking dependency.
    // session.data is not tracked by Glimmer, but isAuthenticated is,
    // so this ensures the getter re-computes after login/logout.
    if (!this.isAuthenticated) return undefined;
    return this.data.authenticated?.user;
  }

  get userRole(): string {
    // Access isAuthenticated to establish Glimmer tracking dependency.
    // session.data is not tracked by Glimmer, but isAuthenticated is,
    // so this ensures the getter re-computes after login/logout.
    if (!this.isAuthenticated) return 'user';
    return this.user?.role ?? 'user';
  }

  get isAdmin(): boolean {
    return this.userRole === 'admin';
  }

  get isModerator(): boolean {
    return this.userRole === 'moderator' || this.userRole === 'admin';
  }
}

declare module '@ember/service' {
  interface Registry {
    session: Session;
  }
}
